<template>
    <main>
       <div class="container-fluid">
            <div class="row">
               <div class="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="mainButton">
                        <breadcrumbs></breadcrumbs>
                    </div>
                    <div class="page-toolbar">
                        <div class="page-title">
                            <span class="title">Budgets</span> 
                            <span class="star"> <i class="fa-solid fa-star"></i></span>
                        </div>
                        <div class="page-create-button">
                            <router-link to="/modules/studybudgets/edit" class="btn-create">Create</router-link>
                        </div>
                        <div class="page-filter">
                            <input type="search" value="" placeholder="Searching..." class="form-control" v-on:click="openAction">
                            <CustomSearch v-bind:class="{ active: isActive }" @searchEvent="childMethod" @openAction="openAction"></CustomSearch>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <GenericList v-if="generic" ref="loadGeneric"></GenericList>
        <CustomList v-else ref="loadCustom"></CustomList>

    </main>
</template>



<script>
import { ref } from "vue";
import breadcrumbs from "@/views/modules/StudyBudgets/MenuList.vue";
import lang from "@/views/modules/StudyBudgets/language/en";
import GenericList from "@/components/layout/shared/generic/ListView.vue";
import CustomList from "@/views/modules/StudyBudgets/ListView.vue";
import CustomSearch from "@/views/modules/StudyBudgets/SearchView.vue";
export default {
name: "list-studybudgets",
components: {
    breadcrumbs,
    GenericList,
    CustomList,
    CustomSearch,
    },
    data(){
        return{
            generic: true,
            isActive:false,
            metaList:[
                {
                    label: lang.LBL_TEMPLATE_NAME,
                    link:true,
                    width:300,
                    moduleName:'StudyBudgets',/// moduleName is required
                    routePath:'studybudgets',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'name'
                },
                {
                    label: lang.LBL_CURRENCY_MULTIPLIER,
                    link:false,
                    width:30,
                    routePath:'StudyBudgets',/// routePath is required at start of object
                    isSort: true,
                    field_name: 'currency_multiplier'
                },
                {
                    label: lang.LBL_TEMPLATE_YEAR,
                    link:false,
                    width:30,
                    routePath:'',
                    isSort: true,
                    field_name: 'template_year'
                },
                {
                    label: lang.LBL_TEMPLATE_STATUS,
                    link:false,
                    width:50,
                    routePath:'',
                    isSort: true,
                    field_name: 'template_status'
                }
            ],
            columns: ['name', 'currency_multiplier', 'template_years', 'template_status'],

        }
    },
    mounted() {
        this.childMethod();
        this.$emit('MetaView','Awesome')
    },
    methods:{
        childMethod(search=''){
            if(this.generic == true){
                this.$refs.loadGeneric.loadGenericView(this.metaList,this.columns,search);
            }
        },
        openAction() {
            this.isActive = !this.isActive;
        }, 
    }
}

</script>



